import { useMemo } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';

export const useHideIntroVariantSelector = () => {
  const { state } = useWorkFlowCanvas();

  return useMemo(() => state.showIntroVariant, [state.showIntroVariant]);
};
